/**
 * Labstep
 *
 * @module components/FilterPost/Report/Date
 * @desc Filter by a date field
 */

import { FilterPostReportDateForm } from 'labstep-web/components/FilterPost/Report/Date/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FilterPostReportDateProps } from './types';

export const FilterPostReportDate: React.FC<
  FilterPostReportDateProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  replace,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
        dataCy="components/FilterPost/Report/Date"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportDateForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
        replace={replace}
      />
    )}
    {...rest}
  />
);
